module.exports = __webpack_public_path__ + "img/programmeBanner.fc615910.png";